import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { BridgesPage } from '@/features/admin/bridges/bridge-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Bridges vers un cluster Hadoop existant. La page courante vit dans l'URL (`?page=`), la première ne l'écrit pas. */
export const Route = createFileRoute('/$tenant/bridges/')({
  validateSearch: (search: Record<string, unknown>): { page?: number } => {
    const page = Number(search['page']);
    return Number.isInteger(page) && page > 0 ? { page } : {};
  },
  component: BridgesRoute,
});

function BridgesRoute() {
  const { tenant } = Route.useParams();
  const { page = 0 } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="bridges" crumbs={[{ label: t('nav.items.bridges') }]}>
      <BridgesPage
        tenantId={tenant}
        page={page}
        onPageChange={(next) => void navigate({ search: next > 0 ? { page: next } : {}, replace: true })}
      />
    </ConsoleShell>
  );
}
